import React from 'react';
import { Box } from '@mui/material';
import PortfolioSummarySkeleton from './PortfolioSummarySkeleton';
import PortfolioHoldingsSkeleton from './PortfolioHoldingsSkeleton';

interface CurrentPortfolioSkeletonProps {
  holdingCount?: number;
}

const CurrentPortfolioSkeleton: React.FC<CurrentPortfolioSkeletonProps> = ({ 
  holdingCount = 6 
}) => {
  return (
    <Box>
      <PortfolioSummarySkeleton />
      
      <Box mt={4}>
        <PortfolioHoldingsSkeleton holdingCount={holdingCount} />
      </Box>
    </Box>
  );
};

export default CurrentPortfolioSkeleton;